export default __webpack_public_path__ + "static/media/x-square.b8dd0ce6.svg";